import React, { useContext, useMemo } from "react";
import { MainContext } from "../../main-context";
import InspectionList from "./InspectionList";
import offline_css from "../offline.module.css";
import Spinner from "../helpers/Spinner";

export default function DailyWeekly({
  params_type,
  setSelectedTerminal,
  setSelectedAirline,
  inspectionFilter,
  existsInDatabase,
  selectedTerminal,
}) {
  const main_context = useContext(MainContext);

  const dailyWeeklyReady = useMemo(() => {
    return (
      !!main_context.inspections &&
      !!main_context.inspections[params_type] &&
      !!main_context.inspections[params_type].length
    );
  }, [main_context.inspections, params_type]);

  const dailyWeeklyNoInspections = useMemo(() => {
    return (
      !!main_context.inspections &&
      !!main_context.inspections[params_type] &&
      !main_context.inspections[params_type].length
    );
  }, [main_context.inspections, params_type]);

  const getTerminals = useMemo(() => {
    const terminals = {};
    if (dailyWeeklyReady) {
      const inspections = main_context.inspections[params_type];
      for (const inspection of inspections) {
        if (inspection.terminal) {
          terminals[inspection.terminal] = true;
        }
      }
    }

    return Object.keys(terminals);
  }, [dailyWeeklyReady, main_context.inspections, params_type]);

  return (
    <div>
      <MainContext.Consumer>
        {({ inspections }) => (
          <>
            <h2 className="text-center">
              Click on equipment to start inspection
            </h2>
            {!inspections && (
              <h1 className="text-center">
                Loading...
                <Spinner
                  waitfor={inspections}
                  className={offline_css["daily-spinner"]}
                ></Spinner>
              </h1>
            )}
            {dailyWeeklyNoInspections && (
              <h3 className="text-center font-weight-bold">
                <strong>No Inspections Scheduled</strong>
              </h3>
            )}
            {dailyWeeklyReady && (
              <div className="container">
                <div
                  className="row"
                  style={{
                    display: "flex",
                    justifyContent: "space-evenly",
                  }}
                >
                  {!!getTerminals.length && (
                    <div
                      className="col-xs-4"
                      style={{
                        justifyContent: "center",
                        display: "flex",
                      }}
                    >
                      <select
                        style={{
                          maxWidth: "200px",
                        }}
                        className="form-control"
                        onChange={(event) =>
                          setSelectedTerminal(event.target.value)
                        }
                        value={selectedTerminal}
                      >
                        <option value="">Filter</option>
                        {getTerminals.map((elem) => (
                          <option key={elem} value={elem}>
                            {elem}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}
                </div>
                <div className="row">
                  {params_type !== "maintenance" && (
                    <div
                      className="col-xs-12"
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                        justifyContent: "center",
                        marginTop: "20px",
                      }}
                    >
                      <InspectionList
                        existsInDatabase={existsInDatabase}
                        setSelectedAirline={setSelectedAirline}
                        inspection-airlines={inspections.airlines}
                        inspectionFilter={inspectionFilter}
                        offline_css={offline_css}
                        type={params_type}
                      ></InspectionList>
                    </div>
                  )}
                </div>
              </div>
            )}
          </>
        )}
      </MainContext.Consumer>
    </div>
  );
}
